import { Suspense, lazy } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { squillaQui } from "@/lib/squillo";

/**
 * LO SQUILLO DEL BANCO SU OGNI PAGINA (Davide, 06/10/2026: «deve suonare chi
 * ha loggato supporto@, in qualunque stato, che sia telefono, browser etc»).
 *
 * Fino a oggi suonava solo la pagina della postazione (/banco-operatore): con
 * supporto@ aperto sulla chat, sul pannello o nell'app del telefono, un
 * installatore poteva aspettare un tecnico nel silenzio. Ora, dovunque sia
 * aperto l'account della postazione, una vedetta legge la coda del banco con
 * la STESSA regola della postazione (lib/squillo), squilla in orario e mostra
 * in cima «Un installatore aspetta un tecnico → Apri la postazione».
 *
 * Il telefono bloccato o con l'app chiusa non lo raggiunge nessuna pagina: li'
 * arriva la notifica push che parte da richiedi-operatore.
 *
 * Per tutti gli altri account qui non succede niente (e la vedetta non viene
 * nemmeno scaricata). Sulla postazione suona la pagina stessa: due suonerie
 * sulla stessa schermata si pesterebbero i piedi.
 */
const VedettaBanco = lazy(() => import("./VedettaBanco"));

export function SquilloOvunque() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!squillaQui(user?.email)) return null;
  if (pathname.startsWith("/banco-operatore")) return null;
  return (
    <Suspense fallback={null}>
      <VedettaBanco />
    </Suspense>
  );
}
